import { getPrimaryColor } from '@brands/Utils/getPrimaryColor';
import { Box, LinearProgress, styled } from '@mui/material';
import React from 'react';

type LinearProgressDisplayProps = {
  progress: number;
  color?: string;
};

const DEFAULT_PROGRESS_COLOR = '#1ba1e0';

const sanitizeHexColor = (color?: string): string => {
  const raw = (color ?? DEFAULT_PROGRESS_COLOR).trim();
  const withHash = raw.startsWith('#') ? raw : `#${raw}`;
  return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(withHash) ? withHash : DEFAULT_PROGRESS_COLOR;
};

const hexToRgba = (hex: string, alpha: number) => {
  let c = sanitizeHexColor(hex).replace('#', '');
  if (c.length === 3)
    c = c
      .split('')
      .map((x) => x + x)
      .join('');
  const bigint = parseInt(c, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const BorderLinearProgress = styled(LinearProgress)<{ barcolor: string }>(({ barcolor }) => ({
  height: 10,
  borderRadius: 5,
  backgroundColor: hexToRgba(barcolor, 0.08),
  '& .MuiLinearProgress-bar': {
    borderRadius: 5,
    backgroundColor: barcolor,
  },
}));

const LinearProgressDisplay: React.FC<LinearProgressDisplayProps> = ({ progress, color }) => (
  <Box sx={{ width: '100%', padding: 2 }}>
    <BorderLinearProgress variant="determinate" value={progress} barcolor={sanitizeHexColor(color || getPrimaryColor())} />
  </Box>
);

export default LinearProgressDisplay;
